import React from 'react';

const SvgTm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="TM_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
      <ellipse id="TM_svg__c" cx={2} cy={1.333} rx={2} ry={1.333} />
      <ellipse id="TM_svg__e" cx={2} cy={1.333} rx={2} ry={1.333} />
      <ellipse id="TM_svg__g" cx={2} cy={1.333} rx={2} ry={1.333} />
      <ellipse id="TM_svg__i" cx={2} cy={0.667} rx={2} ry={1} />
      <ellipse id="TM_svg__j" cx={2} cy={1.333} rx={2} ry={1.333} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TM_svg__b" fill="#fff">
        <use xlinkHref="#TM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TM_svg__a" />
      <path fill="#30C375" mask="url(#TM_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#DE414F" mask="url(#TM_svg__b)" d="M4 0h4v20H4z" />
      <g mask="url(#TM_svg__b)">
        <g transform="translate(4 1.333)">
          <mask id="TM_svg__d" fill="#fff">
            <use xlinkHref="#TM_svg__c" />
          </mask>
          <use fill="#FFF" xlinkHref="#TM_svg__c" />
          <circle
            fill="#DD404F"
            mask="url(#TM_svg__d)"
            cx={2}
            cy={1.333}
            r={1}
          />
          <path
            fill="#FBAF29"
            mask="url(#TM_svg__d)"
            d="M0 0h2v1.333H0zM2 1.333h2v1.333H2z"
          />
        </g>
      </g>
      <g mask="url(#TM_svg__b)">
        <g transform="translate(4 16)">
          <mask id="TM_svg__f" fill="#fff">
            <use xlinkHref="#TM_svg__e" />
          </mask>
          <use fill="#FFF" xlinkHref="#TM_svg__e" />
          <circle
            fill="#DD404F"
            mask="url(#TM_svg__f)"
            cx={2}
            cy={1.333}
            r={1}
          />
          <path
            fill="#FBAF29"
            mask="url(#TM_svg__f)"
            d="M0 0h2v1.333H0zM2 1.333h2v1.333H2z"
          />
        </g>
      </g>
      <g mask="url(#TM_svg__b)">
        <g transform="translate(4 9.333)">
          <mask id="TM_svg__h" fill="#fff">
            <use xlinkHref="#TM_svg__g" />
          </mask>
          <use fill="#28AE67" xlinkHref="#TM_svg__g" />
          <ellipse
            fill="#DD404F"
            mask="url(#TM_svg__h)"
            cx={2}
            cy={1.333}
            rx={1.333}
            ry={1}
          />
        </g>
      </g>
      <g mask="url(#TM_svg__b)">
        <use
          fill="#28AE67"
          xlinkHref="#TM_svg__i"
          transform="translate(4 13.333)"
        />
      </g>
      <g mask="url(#TM_svg__b)">
        <g transform="translate(4 5.333)">
          <mask id="TM_svg__k" fill="#fff">
            <use xlinkHref="#TM_svg__j" />
          </mask>
          <use fill="#FBAF29" xlinkHref="#TM_svg__j" />
          <circle
            fill="#DD404F"
            mask="url(#TM_svg__k)"
            cx={2}
            cy={1.333}
            r={1}
          />
          <path
            fill="#28AE67"
            mask="url(#TM_svg__k)"
            d="M0 0h1.333v2.667H0zM2.667 0H4v2.667H2.667z"
          />
        </g>
      </g>
      <path
        d="M14.823 4.238a.667.667 0 1 0 1.021.857.667.667 0 0 0-1.021-.857zm-1.728 2.585a.667.667 0 1 0-.857 1.021.667.667 0 0 0 .857-1.021zm-1.333-1.334a.667.667 0 1 0-.857 1.022.667.667 0 0 0 .857-1.022zm2.667-2.666a.667.667 0 1 0-.858 1.021.667.667 0 0 0 .858-1.021zm-.667 2a.667.667 0 1 0-.857 1.021.667.667 0 0 0 .857-1.021z"
        fill="#FFF"
        mask="url(#TM_svg__b)"
      />
      <path
        d="M17.476 9.45a4.066 4.066 0 0 1-6.168-.487 4.067 4.067 0 0 0 5.68-5.68 4.066 4.066 0 0 1 .488 6.168z"
        fill="#FFF"
        mask="url(#TM_svg__b)"
      />
    </g>
  </svg>
);

export default SvgTm;
